import { lazy } from 'react'
import { InterviewVideoModal } from '../pages/platform/CurriculumPage/InterviewsTab/InterviewVideoModal'

export const MODAL_NAME = {
  user: 'users',
  group: 'groups',
  tenant: 'tenants',
  historyMission: 'historyMission',
  noResultsReport: 'noResultsReport',
  translate: 'translate',
  customer: 'customer',
  curriculum: 'curriculum',
  curriculumExperience: 'curriculumExperience',
  curriculumFormazione: 'curriculumFormazione',
  curriculumCertification: 'curriculumCertification',
  curriculumLanguage: 'curriculumLanguage',
  curriculumUpdates: 'curriculumUpdates',
  createInterview: 'createInterview',
  curriculumPrivacy: 'curriculumPrivacy',
  curriculumTraining: 'curriculumTraining',
  candidate: 'candidati',
  projectCandidate: 'projectCandidate',
  customerUpdates: 'customerUpdates',
  emailTemplate: 'emailTemplates',
  sendEmail: 'sendEmail',
  statusHistory: 'statusHistory',
  recluteSummary: 'recluteSummary',
  contact: 'contacts',
  meeting: 'meeting',
  document: 'document',
  deal: 'deals',
  advancedSearch: 'advancedSearch',
  uploadCv: 'uploadCv',
  manageLabel: 'manageLabel',
  duplicateCandidates: 'duplicateCandidates',
  labelEdit: 'labelEdit',
  companyForm: 'companyForm',
  postsForm: 'PostsForm',
  assignLabel: 'assignLabel',
  userLabel: 'userLabel',
  documentTemplate: 'documentTemplate',
  documentTemplateList: 'documentTemplateList',
  shortcode: 'shortcode',
  course: 'course',
  emailDisplay: 'emailDisplay',
  documentPreview: 'documentPreview',
  reminder: 'reminder',
  advancedSearchHelp: 'advancedSearchHelp',
  semanticSearchHelp: 'semanticSearchHelp',
  calendarNewOptions: 'calendarNewOptions',
  restoreConfirmation: 'restoreConfirmation',
  copyCode: 'copyCode',
  chat: 'chat',
  skill: 'skill',
  transferSkill: 'transferSkill',
  candidateDetail: 'candidateDetail',
  answerAd: 'answerAd',
  curriculumInterview: 'curriculumInterview',
  interviewVideo: 'interviewVideo',
  skillSearch: 'skillSearch',
  itemCode: 'itemCode',
  pipeline: 'pipeline',
  profession: 'profession',
  emailTimeline: 'emailTimeline',
  externalChannels: 'externalChannels',
  jobDescriptionHelp: 'jobDescriptionHelp',
  pickEmailTemplate: 'pickEmailTemplate',
  jobAd: 'jobAd',
  calendarShareModal: 'calendarShareModal',
  infinityModal: 'infinityModal',
  dynasetModal: 'dynasetModal',
  uploadExcelCv: 'uploadExcelCv',
  itemCodesOrderModal: 'itemCodesOrderModal',
  pipelineItemCodesOrderModal: 'pipelineItemCodesOrderModal',
  itemCodesModal: 'itemCodesModal',
  itemCodesSelectModal: 'itemCodesSelectModal',
  surveyForm: 'surveyForm',
  surveyQuestionsOrderModal: 'surveyQuestionsOrderModal',
  surveyQuestionsTable: 'surveyQuestionsTable',
  surveyQuestionForm: 'surveyQuestionForm',
  automaticActionsForm: 'automaticActionsForm',
  sendInviteSurvey: 'sendInviteSurvey',
  changeGroupAction: 'changeGroupAction',
  changeStatusAction: 'changeStatusAction',
  automaticActionsModal: 'automaticActionsModal',
  exportModal: 'exportModal',
  exportProjectModal: 'exportProjectModal',
  userAdd: 'userAdd',
  userAddFamily: 'userAddFamily',
  documentArea: 'documentArea',
  coursesCandidate: 'coursesCandidate',
  interviewStarted: 'interviewStarted',
  transfer: 'transfer',
  changeStatus: 'changeStatus'
}

const modals = {
  // performa
  [MODAL_NAME.user]: {
    Component: lazy(() => import('../pages/platform/UsersPage/UserForm')),
  },
  [MODAL_NAME.group]: {
    Component: lazy(() => import('../pages/platform/GroupsPage/GroupForm')),
  },
  [MODAL_NAME.tenant]: {
    Component: lazy(() => import('../pages/platform/TenantsPage/TenantForm')),
  },
  [MODAL_NAME.translate]: {
    Component: lazy(() => import('../pages/platform/TranslatePage/TranslateForm')),
  },
  [MODAL_NAME.customer]: {
    Component: lazy(() => import('../pages/platform/CustomersPage/CustomersForm')),
  },
  [MODAL_NAME.curriculum]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/CurriculumForm')),
  },
  [MODAL_NAME.curriculumExperience]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/FormTabs/ExperienceModal')),
  },

  [MODAL_NAME.curriculumFormazione]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/FormTabs/InstructionModal')),
  },
  [MODAL_NAME.curriculumCertification]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/FormTabs/CertificationModal')),
  },
  [MODAL_NAME.curriculumLanguage]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/FormTabs/LanguageModal')),
  },
  [MODAL_NAME.curriculumUpdates]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/FormTabs/UpdatesModal')),
  },
  [MODAL_NAME.historyMission]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/FormTabs/UpdateHistoryMission')),
  },
  [MODAL_NAME.createInterview]: {
    Component: lazy(() => import('../pages/platform/ItemCodesPage/CreateInterviewModal')),
  },
  [MODAL_NAME.curriculumPrivacy]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/FormTabs/PrivacyModal')),
  },
  [MODAL_NAME.curriculumTraining]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/FormTabs/TrainingModal')),
  },
  [MODAL_NAME.projectCandidate]: {
    Component: lazy(() =>
      import('../pages/platform/ProjectsPage/ProjectCandidatesTab/ProjectCandidateForm'),
    ),
  },
  [MODAL_NAME.meeting]: {
    Component: lazy(() => import('../pages/platform/CalendarsPage/MeetingsForm')),
  },
  [MODAL_NAME.document]: {
    Component: lazy(() => import('../pages/platform/DocumentPage/DocumentForm')),
  },
  // qui altre modal

  [MODAL_NAME.customerUpdates]: {
    Component: lazy(() => import('../pages/platform/CustomersPage/Tabs/UpdatesForm')),
  },
  [MODAL_NAME.emailTemplate]: {
    Component: lazy(() => import('../pages/platform/EmailTemplatePage/EmailTemplateForm')),
  },
  [MODAL_NAME.sendEmail]: {
    Component: lazy(() => import('../pages/platform/DocumentPage/SendEmailForm')),
  },
  [MODAL_NAME.statusHistory]: {
    Component: lazy(() => import('components/platform/app/HistoryButton')),
  },
  [MODAL_NAME.recluteSummary]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/CandidateHeader/RecluteSummaryButton')),
  },
  [MODAL_NAME.contact]: {
    Component: lazy(() => import('../pages/platform/ContactsPage/ContactsForm')),
  },
  [MODAL_NAME.deal]: {
    Component: lazy(() => import('../pages/platform/ProjectsPage/ProjectDealsTab/DealForm')),
  },
  [MODAL_NAME.advancedSearch]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/AdvancedSearchForm')),
  },
  [MODAL_NAME.uploadCv]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/UploadCvForm')),
  },
  [MODAL_NAME.uploadExcelCv]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/UploadExcelForm')),
  },
  [MODAL_NAME.manageLabel]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/Labels/LabelsModal')),
  },
  [MODAL_NAME.duplicateCandidates]: {
    Component: lazy(() => import('../pages/platform/ProjectsPage/AnswerAdsTab/DuplicatesModal')),
  },
  [MODAL_NAME.labelEdit]: {
    Component: lazy(() =>
      import('../pages/platform/CurriculumPage/Labels/LabelForm').then(module => ({
        default: module.LabelEdit,
      })),
    ),
  },
  [MODAL_NAME.companyForm]: {
    Component: lazy(() => import('../pages/platform/SettingsPage/FormTabs/Companies/CompanyForm')),
  },
  [MODAL_NAME.postsForm]: {
    Component: lazy(() => import('../pages/home/PostsForm')),
  },
  [MODAL_NAME.assignLabel]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/Labels/AssignLabelForm')),
  },
  [MODAL_NAME.userLabel]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/Labels/UserLabelForm')),
  },
  [MODAL_NAME.documentTemplate]: {
    Component: lazy(() => import('../pages/platform/DocumentsTemplatePage/DocumentTemplateForm')),
  },
  [MODAL_NAME.shortcode]: {
    Component: lazy(() =>
      import('../pages/platform/DocumentsTemplatePage/Shortcode/ShortcodeForm'),
    ),
  },
  [MODAL_NAME.jobAd]: {
    Component: lazy(() =>
      import('../pages/platform/JobAdsPage/JobAdForm').then(module => ({
        default: module.JobAdModalForm,
      })),
    ),
  },
  [MODAL_NAME.course]: {
    Component: lazy(() =>
      import('../pages/platform/CoursesCertificationPage/CourseCertificationForm'),
    ),
  },
  [MODAL_NAME.emailDisplay]: {
    Component: lazy(() => import('../pages/platform/EmailOutboxPage/EmailDisplayForm')),
  },
  [MODAL_NAME.documentTemplateList]: {
    Component: lazy(() => import('../pages/platform/DocumentsTemplatePage/DocumentTemplateList')),
  },
  [MODAL_NAME.documentPreview]: {
    Component: lazy(() => import('../pages/platform/DocumentPage/DocumentPreview')),
  },
  [MODAL_NAME.reminder]: {
    Component: lazy(() => import('../pages/platform/CalendarsPage/ReminderForm')),
  },
  [MODAL_NAME.advancedSearchHelp]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/AdvancedSearchHelp')),
  },
  [MODAL_NAME.semanticSearchHelp]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/SemanticSearchHelp')),
  },
  [MODAL_NAME.calendarNewOptions]: {
    Component: lazy(() => import('../pages/platform/CalendarsPage/CalendarNewOptions')),
  },
  [MODAL_NAME.copyCode]: {
    Component: lazy(() =>
      import('../pages/platform/SettingsPage/FormTabs/TabAdvertisement/CodeCopyForm'),
    ),
  },
  [MODAL_NAME.chat]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/TalentTab/Chat/ChatDialog')),
  },
  [MODAL_NAME.skill]: {
    Component: lazy(() => import('../pages/platform/SkillsPage/SkillForm')),
  },
  [MODAL_NAME.profession]: {
    Component: lazy(() =>
      import('../pages/platform/SkillsPage/SkillForm').then(module => ({
        default: module.ProfessionsForm,
      })),
    ),
  },
  [MODAL_NAME.transferSkill]: {
    Component: lazy(() => import('../pages/platform/SkillsPage/TransferSkillForm')),
  },
  [MODAL_NAME.candidateDetail]: {
    Component: lazy(() =>
      import('../pages/platform/ProjectsPage/Dataroom/CandidateDetailDataroom'),
    ),
  },
  [MODAL_NAME.answerAd]: {
    Component: lazy(() => import('../pages/platform/ProjectsPage/AnswerAdsTab/AnswerAdModal')),
  },
  [MODAL_NAME.curriculumInterview]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/InterviewsTab/InterviewModal')),
  },
  [MODAL_NAME.interviewVideo]: {
    screen: InterviewVideoModal,
  },
  [MODAL_NAME.skillSearch]: {
    Component: lazy(() => import('../pages/platform/ProjectsPage/AnswerAdsTab/SkillSearch')),
  },
  [MODAL_NAME.itemCode]: {
    Component: lazy(() => import('../pages/platform/ItemCodesPage/ItemCodeForm')),
  },
  [MODAL_NAME.itemCodesModal]: {
    Component: lazy(() => import('../pages/platform/PipelinePage/ItemCodesModal')),
  },
  [MODAL_NAME.itemCodesSelectModal]: {
    Component: lazy(() => import('../pages/platform/PipelinePage/ItemCodesSelectModal')),
  },
  [MODAL_NAME.pipeline]: {
    Component: lazy(() => import('../pages/platform/PipelinePage/PipelineForm'))
  },
  [MODAL_NAME.externalChannels]: {
    Component: lazy(() =>
      import('../pages/platform/JobAdsPage/ExternalChannels/ExternalChannelsForm'),
    ),
  },
  [MODAL_NAME.jobDescriptionHelp]: {
    Component: lazy(() => import('../pages/platform/JobAdsPage/JobDescriptionHelp')),
  },
  [MODAL_NAME.userAdd]: {
    Component: lazy(() =>
      import('../pages/platform/CurriculumPage/AreaCandidate/FormTabs/DocumentArt53/ModalAddUser'),
    ),
  },
  [MODAL_NAME.userAddFamily]: {
    Component: lazy(() =>
      import(
        '../pages/platform/CurriculumPage/AreaCandidate/FormTabs/DocumentArt53/ModalAddUserFamily'
      ),
    ),
  },
  [MODAL_NAME.documentArea]: {
    Component: lazy(() =>
      import('../pages/platform/CurriculumPage/AreaCandidate/FormTabs/Documents/DocumentsFormArea'),
    ),
  },
  openEditor: {
    Component: lazy(() =>
      import('../components/platform/Dialog/OpenDialog').then(module => ({
        default: module.OpenDialog,
      })),
    ),
  },
  emailTimeline: {
    Component: lazy(() => import('../pages/platform/EmailOutboxPage/EmailTimelineModal')),
  },
  pickEmailTemplate: {
    Component: lazy(() => import('../pages/platform/CalendarsPage/PickEmailTemplate')),
  },
  calendarShareModal: {
    Component: lazy(() => import('../pages/platform/CalendarsPage/CalendarShareModal')),
  },
  infinityModal: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/CandidateHeader/InfinityModal')),
  },
  dynasetModal: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/CandidateHeader/DynasetModal')),
  },
  itemCodesOrderModal: {
    Component: lazy(() => import('../pages/platform/ItemCodesPage/ItemCodesOrderModal')),
  },
  pipelineItemCodesOrderModal: {
    Component: lazy(() => import('../pages/platform/PipelinePage/PipelineStatusOrderModal'))
  },
  surveyForm: {
    Component: lazy(() => import('../pages/platform/SurveysPage/SurveyForm')),
  },
  surveyQuestionsOrderModal: {
    Component: lazy(() => import('../pages/platform/SurveysPage/Questions/QuestionsOrderModal')),
  },
  surveyQuestionsTable: {
    Component: lazy(() => import('../pages/platform/SurveysPage/Questions/QuestionsTable')),
  },
  surveyQuestionForm: {
    Component: lazy(() => import('../pages/platform/SurveysPage/Questions/QuestionForm')),
  },
  automaticActionsForm: {
    Component: lazy(() => import('../pages/platform/ItemCodesPage/AutomaticActionsForm')),
  },
  sendInviteSurvey: {
    Component: lazy(() => import('../pages/platform/ItemCodesPage/SendInviteSurvey')),
  },
  automaticActionsModal: {
    Component: lazy(() => import('../pages/platform/ItemCodesPage/AutomaticActionsModal')),
  },
  changeGroupAction: {
    Component: lazy(() => import('../pages/platform/ItemCodesPage/ChangeGroupAction'))
  },
  changeStatusAction: {
    Component: lazy(() => import('../pages/platform/ItemCodesPage/ChangeStatusAction'))
  },
  [MODAL_NAME.exportModal]: {
    Component: lazy(() => import('../pages/platform/ExportModals/ExportModal')),
  },
  [MODAL_NAME.exportProjectModal]: {
    Component: lazy(() => import('../pages/platform/ExportModals/ExportProjectsModal')),
  },
  [MODAL_NAME.coursesCandidate]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/FormTabs/CoursesModal')),
  },
  [MODAL_NAME.interviewStarted]: {
    Component: lazy(() => import('../pages/platform/SurveysPage/InterviewStartedModal')),
  },
  [MODAL_NAME.transfer]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/TransferModal'))
  },
  [MODAL_NAME.noResultsReport]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/NoResultsModal')),
  },
  [MODAL_NAME.noResultsReport]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/NoResultsModal')),
  },
  [MODAL_NAME.changeStatus]: {
    Component: lazy(() => import('../pages/platform/CurriculumPage/ChangeStatusModal'))
  }
} as const

/* export type ModalNamesType = keyof typeof modals

export type ScreenProps = React.ComponentProps<typeof modals["automaticActionsModal"]["screen"]>

export type ScreenKeyProps = { [name in keyof typeof modals]: (props: React.ComponentProps<typeof modals[name]["screen"]> ) => void }

const ciao : ScreenProps = {
  actions: ""
}

const ciao2: ScreenKeyProps = {} as any

ciao2.curriculumPrivacy({

})
 */

export default modals
